import { doc, getDoc } from "firebase/firestore";

import { db } from "../firebase/config";

// export const getMemberByAccessToken = async (token) => {
//   const portalSnap = await getDoc(doc(db, "memberPortal", token));

//   if (!portalSnap.exists()) return null;

//   const portal = portalSnap.data();

//   const memberSnap = await getDoc(
//     doc(db, "gyms", portal.gymId, "members", portal.memberId),
//   );

//   const gymSnap = await getDoc(doc(db, "gyms", portal.gymId));

//   return {
//     member: {
//       id: memberSnap.id,
//       ...memberSnap.data(),
//     },

//     gym: gymSnap.data(),

//     gymId: portal.gymId,
//   };
// };

export const getMemberByAccessToken = async (token) => {
  console.log("Portal Token:", token);

  const portalRef = doc(db, "memberPortal", token);
  const portalSnap = await getDoc(portalRef);

  console.log("Portal Exists:", portalSnap.exists());

  if (!portalSnap.exists()) {
    console.log("Portal document not found");
    return null;
  }

  const portal = portalSnap.data();

  console.log("Portal Data:", portal);

  const memberSnap = await getDoc(
    doc(db, "gyms", portal.gymId, "members", portal.memberId),
  );

  console.log("Member Exists:", memberSnap.exists());

  const gymSnap = await getDoc(doc(db, "gyms", portal.gymId));

  console.log("Gym Exists:", gymSnap.exists());

  return {
    member: {
      id: memberSnap.id,
      ...memberSnap.data(),
    },
    gym: gymSnap.data(),
    gymId: portal.gymId,
  };
};
